<template>
	<span>
		<purchase-form-details></purchase-form-details>
		<page-footer></page-footer>
	</span>
</template>
<script>
	import PurchaseFormDetails from "@/components/PurchaseFormDetails";
	import PageFooter from "@/components/PageFooter";
	export default {
		name: "purchaseform",
		components: {
			PurchaseFormDetails,
			PageFooter,
		},
	};
</script>
